/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import _ from "lodash";
import { VAT_MULTIPLIER, VAT_MULTIPLIER_OLD } from "../../services/globalVars";
import { STATUS_SUBMITTED } from "../../services/LeadStatus/StatusDivorce";
import { Divorce } from "../../types/Products/FamilyLaw/Divorce";
import dayjs from "dayjs";

class FeesService {
  static rvgFees: FeeCollection = [
    { value: 500, fee: 51.5 },
    { value: 1000, fee: 93 },
    { value: 1500, fee: 134.5 },
    { value: 2000, fee: 176 },
    { value: 3000, fee: 235.5 },
    { value: 4000, fee: 295 },
    { value: 5000, fee: 354.5 },
    { value: 6000, fee: 414 },
    { value: 7000, fee: 473.5 },
    { value: 8000, fee: 533 },
    { value: 9000, fee: 592.5 },
    { value: 10000, fee: 652 },
    { value: 13000, fee: 707 },
    { value: 16000, fee: 762 },
    { value: 19000, fee: 817 },
    { value: 22000, fee: 872 },
    { value: 25000, fee: 927 },
    { value: 30000, fee: 1013 },
    { value: 35000, fee: 1099 },
    { value: 40000, fee: 1185 },
    { value: 45000, fee: 1271 },
    { value: 50000, fee: 1357 },
    { value: 65000, fee: 1456.5 },
    { value: 80000, fee: 1556 },
    { value: 95000, fee: 1655.5 },
    { value: 110000, fee: 1755 },
    { value: 125000, fee: 1854.5 },
    { value: 140000, fee: 1954 },
    { value: 155000, fee: 2053.5 },
    { value: 170000, fee: 2153 },
    { value: 185000, fee: 2252.5 },
    { value: 200000, fee: 2352 },
    { value: 230000, fee: 2492 },
    { value: 260000, fee: 2632 },
    { value: 290000, fee: 2772 },
    { value: 320000, fee: 2912 },
    { value: 350000, fee: 3052 },
    { value: 380000, fee: 3192 },
    { value: 410000, fee: 3332 },
    { value: 440000, fee: 3472 },
    { value: 470000, fee: 3612 },
    { value: 500000, fee: 3752 },
  ];

  static rvgFeesUntil30052025: FeeCollection = [
    { value: 500, fee: 49 },
    { value: 1000, fee: 88 },
    { value: 1500, fee: 127 },
    { value: 2000, fee: 166 },
    { value: 3000, fee: 222 },
    { value: 4000, fee: 278 },
    { value: 5000, fee: 334 },
    { value: 6000, fee: 390 },
    { value: 7000, fee: 446 },
    { value: 8000, fee: 502 },
    { value: 9000, fee: 558 },
    { value: 10000, fee: 614 },
    { value: 13000, fee: 666 },
    { value: 16000, fee: 718 },
    { value: 19000, fee: 770 },
    { value: 22000, fee: 822 },
    { value: 25000, fee: 874 },
    { value: 30000, fee: 955 },
    { value: 35000, fee: 1036 },
    { value: 40000, fee: 1117 },
    { value: 45000, fee: 1198 },
    { value: 50000, fee: 1279 },
    { value: 65000, fee: 1373 },
    { value: 80000, fee: 1467 },
    { value: 95000, fee: 1561 },
    { value: 110000, fee: 1655 },
    { value: 125000, fee: 1749 },
    { value: 140000, fee: 1843 },
    { value: 155000, fee: 1937 },
    { value: 170000, fee: 2031 },
    { value: 185000, fee: 2125 },
    { value: 200000, fee: 2219 },
    { value: 230000, fee: 2351 },
    { value: 260000, fee: 2483 },
    { value: 290000, fee: 2615 },
    { value: 320000, fee: 2747 },
    { value: 350000, fee: 2879 },
    { value: 380000, fee: 3011 },
    { value: 410000, fee: 3143 },
    { value: 440000, fee: 3275 },
    { value: 470000, fee: 3407 },
    { value: 500000, fee: 3539 },
  ];

  static rvgFees2020: FeeCollection = [
    { value: 500, fee: 45 },
    { value: 1000, fee: 80 },
    { value: 1500, fee: 115 },
    { value: 2000, fee: 150 },
    { value: 3000, fee: 201 },
    { value: 4000, fee: 252 },
    { value: 5000, fee: 303 },
    { value: 6000, fee: 354 },
    { value: 7000, fee: 405 },
    { value: 8000, fee: 456 },
    { value: 9000, fee: 507 },
    { value: 10000, fee: 558 },
    { value: 13000, fee: 604 },
    { value: 16000, fee: 650 },
    { value: 19000, fee: 696 },
    { value: 22000, fee: 742 },
    { value: 25000, fee: 788 },
    { value: 30000, fee: 863 },
    { value: 35000, fee: 938 },
    { value: 40000, fee: 1013 },
    { value: 45000, fee: 1088 },
    { value: 50000, fee: 1163 },
    { value: 65000, fee: 1248 },
    { value: 80000, fee: 1333 },
    { value: 95000, fee: 1418 },
    { value: 110000, fee: 1503 },
    { value: 125000, fee: 1588 },
    { value: 140000, fee: 1673 },
    { value: 155000, fee: 1758 },
    { value: 170000, fee: 1843 },
    { value: 185000, fee: 1928 },
    { value: 200000, fee: 2013 },
    { value: 230000, fee: 2133 },
    { value: 260000, fee: 2253 },
    { value: 290000, fee: 2373 },
    { value: 320000, fee: 2493 },
    { value: 350000, fee: 2613 },
    { value: 380000, fee: 2733 },
    { value: 410000, fee: 2853 },
    { value: 440000, fee: 2973 },
    { value: 470000, fee: 3093 },
    { value: 500000, fee: 3213 },
  ];

  static gkgFees2020: FeeCollection = [
    { value: 500, fee: 35 },
    { value: 1000, fee: 53 },
    { value: 1500, fee: 71 },
    { value: 2000, fee: 89 },
    { value: 3000, fee: 108 },
    { value: 4000, fee: 127 },
    { value: 5000, fee: 146 },
    { value: 6000, fee: 165 },
    { value: 7000, fee: 184 },
    { value: 8000, fee: 203 },
    { value: 9000, fee: 222 },
    { value: 10000, fee: 241 },
    { value: 13000, fee: 267 },
    { value: 16000, fee: 293 },
    { value: 19000, fee: 319 },
    { value: 22000, fee: 345 },
    { value: 25000, fee: 371 },
    { value: 30000, fee: 406 },
    { value: 35000, fee: 441 },
    { value: 40000, fee: 476 },
    { value: 45000, fee: 511 },
    { value: 50000, fee: 546 },
    { value: 65000, fee: 666 },
    { value: 80000, fee: 786 },
    { value: 95000, fee: 906 },
    { value: 110000, fee: 1026 },
    { value: 125000, fee: 1146 },
    { value: 140000, fee: 1266 },
    { value: 155000, fee: 1386 },
    { value: 170000, fee: 1506 },
    { value: 185000, fee: 1626 },
    { value: 200000, fee: 1746 },
    { value: 230000, fee: 1925 },
    { value: 260000, fee: 2104 },
    { value: 290000, fee: 2283 },
    { value: 320000, fee: 2462 },
    { value: 350000, fee: 2641 },
    { value: 380000, fee: 2820 },
    { value: 410000, fee: 2999 },
    { value: 440000, fee: 3178 },
    { value: 470000, fee: 3357 },
    { value: 500000, fee: 3536 },
  ];

  static gkgFeesUntil30052025: FeeCollection = [
    { value: 500, fee: 38 },
    { value: 1000, fee: 58 },
    { value: 1500, fee: 78 },
    { value: 2000, fee: 98 },
    { value: 3000, fee: 119 },
    { value: 4000, fee: 140 },
    { value: 5000, fee: 161 },
    { value: 6000, fee: 182 },
    { value: 7000, fee: 203 },
    { value: 8000, fee: 224 },
    { value: 9000, fee: 245 },
    { value: 10000, fee: 266 },
    { value: 13000, fee: 295 },
    { value: 16000, fee: 324 },
    { value: 19000, fee: 353 },
    { value: 22000, fee: 382 },
    { value: 25000, fee: 411 },
    { value: 30000, fee: 449 },
    { value: 35000, fee: 487 },
    { value: 40000, fee: 525 },
    { value: 45000, fee: 563 },
    { value: 50000, fee: 601 },
    { value: 65000, fee: 733 },
    { value: 80000, fee: 865 },
    { value: 95000, fee: 997 },
    { value: 110000, fee: 1129 },
    { value: 125000, fee: 1261 },
    { value: 140000, fee: 1393 },
    { value: 155000, fee: 1525 },
    { value: 170000, fee: 1657 },
    { value: 185000, fee: 1789 },
    { value: 200000, fee: 1921 },
    { value: 230000, fee: 2119 },
    { value: 260000, fee: 2317 },
    { value: 290000, fee: 2515 },
    { value: 320000, fee: 2713 },
    { value: 350000, fee: 2911 },
    { value: 380000, fee: 3109 },
    { value: 410000, fee: 3307 },
    { value: 440000, fee: 3505 },
    { value: 470000, fee: 3703 },
    { value: 500000, fee: 3901 },
  ];

  static gkgFees: FeeCollection = [
    { value: 500, fee: 40 },
    { value: 1000, fee: 61 },
    { value: 1500, fee: 82 },
    { value: 2000, fee: 103 },
    { value: 3000, fee: 125.5 },
    { value: 4000, fee: 148 },
    { value: 5000, fee: 170.5 },
    { value: 6000, fee: 193 },
    { value: 7000, fee: 215.5 },
    { value: 8000, fee: 238 },
    { value: 9000, fee: 260.5 },
    { value: 10000, fee: 283 },
    { value: 13000, fee: 313.5 },
    { value: 16000, fee: 344 },
    { value: 19000, fee: 374.5 },
    { value: 22000, fee: 405 },
    { value: 25000, fee: 435.5 },
    { value: 30000, fee: 476 },
    { value: 35000, fee: 516.5 },
    { value: 40000, fee: 557 },
    { value: 45000, fee: 597.5 },
    { value: 50000, fee: 638 },
    { value: 65000, fee: 778 },
    { value: 80000, fee: 918 },
    { value: 95000, fee: 1058 },
    { value: 110000, fee: 1198 },
    { value: 125000, fee: 1338 },
    { value: 140000, fee: 1478 },
    { value: 155000, fee: 1618 },
    { value: 170000, fee: 1758 },
    { value: 185000, fee: 1898 },
    { value: 200000, fee: 2038 },
    { value: 230000, fee: 2248 },
    { value: 260000, fee: 2458 },
    { value: 290000, fee: 2668 },
    { value: 320000, fee: 2878 },
    { value: 350000, fee: 3088 },
    { value: 380000, fee: 3298 },
    { value: 410000, fee: 3508 },
    { value: 440000, fee: 3718 },
    { value: 470000, fee: 3928 },
    { value: 500000, fee: 4138 },
    { value: 560000, fee: 4348 },
    { value: 600000, fee: 4558 },
    { value: 650000, fee: 4768 },
    { value: 700000, fee: 4978 },
  ];

  static getFeeByValue(valueInDispute: number, quantifier = 1.0, addVAT = false, oldRvg = false, oldVat = false) {
    let vatMultiplier = 1;
    if (addVAT) {
      vatMultiplier = oldVat ? VAT_MULTIPLIER_OLD : VAT_MULTIPLIER;
    }
    return this.getFeeRow(oldRvg ? this.rvgFees2020 : this.rvgFees, valueInDispute) * quantifier * vatMultiplier;
  }

  static getFeeRow(fees: FeeCollection, valueInDispute: number) {
    let result = _.head(
      fees.filter((o) => {
        return valueInDispute <= o.value;
      })
    );

    if (result === undefined) {
      return 0;
    }

    return result.fee;
  }

  static getCourtCosts(valueInDispute: number, quantifier = 2, divorce: Divorce, oldVat = false) {
    let vatMultiplier = oldVat ? VAT_MULTIPLIER_OLD : VAT_MULTIPLIER;
    let referenceFeeDate = divorce.powerOfAttorney;
    if (divorce.hasProcessCostSupport) {
      const logEntryFirstStatusUpdated = _.find(divorce.leadStatusLog, (log) => log.leadStatus === STATUS_SUBMITTED);
      referenceFeeDate = logEntryFirstStatusUpdated?.updated ? logEntryFirstStatusUpdated.updated : null;
    }
    const correspondingFeeTable =
      dayjs(referenceFeeDate) < dayjs("01012021", "DDMMYYYY") ? this.gkgFees2020 : this.gkgFees;

    return this.getFeeRow(correspondingFeeTable, valueInDispute) * quantifier * vatMultiplier;
  }

  static getExpenses(addVAT = false, oldVat = false) {
    let vatMultiplier = 1;
    if (addVAT) {
      vatMultiplier = oldVat ? VAT_MULTIPLIER_OLD : VAT_MULTIPLIER;
    }
    return 20 * vatMultiplier;
  }
}

type FeeCollection = Array<{
  value: number;
  fee: number;
}>;

export default FeesService;
